import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PhonelinkSetupOutlinedIcon from "@mui/icons-material/PhonelinkSetupOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ConnectWithoutContactOutlinedIcon from "@mui/icons-material/ConnectWithoutContactOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

const menuItems = [
  { id: 0, link: "/home", icon: <DashboardIcon />, label: "Dashboard" },
  {
    id: 1,
    link: "/home/store-prices",
    icon: <PriceChangeOutlinedIcon />,
    label: "Store Prices",
  },
  {
    id: 2,
    link: "/home/mobile-app",
    icon: <PhonelinkSetupOutlinedIcon />,
    label: "Mobile Integration",
  },
  {
    id: 3,
    link: "/home/customer-profile",
    icon: <BadgeOutlinedIcon />,
    label: "Customer Profile",
  },
  {
    id: 4,
    link: "/home/loyalty-points",
    icon: <AutoAwesomeOutlinedIcon />,
    label: "Loyalty Points",
  },
  {
    id: 5,
    link: "/home/scheme-generation",
    icon: <LocalOfferOutlinedIcon />,
    label: "Scheme Initiation",
  },
  {
    id: 6,
    link: "/home/message-configuration",
    icon: <ConnectWithoutContactOutlinedIcon />,
    label: "Message Configuration",
  },
  {
    id: 7,
    link: "/home/user",
    icon: <ManageAccountsOutlinedIcon />,
    label: "My Profile",
  },
];
const menuItems2 = [
  {
    id: 20,
    icon: <AssessmentOutlinedIcon />,
    label: "Scheme Reports",
    items: [
      {
        id: 201,
        link: "/home/statement",
        icon: <DescriptionOutlinedIcon />,
        label: "Points Statement",
      },
      {
        id: 202,
        link: "/home/scheme-statement",
        icon: <InsertDriveFileOutlinedIcon />,
        label: "Scheme Statement",
      },
      {
        id: 203,
        link: "/home/scheme-summary",
        icon: <SummarizeOutlinedIcon />,
        label: "Scheme Summary",
      },
    ],
  },
  {
    id: 30,
    icon: <AssessmentOutlinedIcon />, // Category icon
    label: "Branch Reports",
    items: [
      {
        id: 11,
        link: "/home/account-ledger",
        icon: <AccountBalanceWalletOutlinedIcon />,
        label: "Account Ledger",
      },
      // {
      //   id: 12,
      //   link: "/home/grouped-stock-report",
      //   icon: <Inventory2OutlinedIcon />,
      //   label: "Grouped Stock Report",
      // },
      // {
      //   id: 13,
      //   link: "/home/combined-grouped-stock-report",
      //   icon: <WarehouseOutlinedIcon />,
      //   label: "Combined Grouped Stock Report",
      // },
    ],
  },
];

const SideMenu = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  toggleMobileMenu,
  closeMobileMenu,
}) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = React.useState({});

  const toggleSubMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const isSubMenuActive = (submenuItems, currentPath) => {
    return submenuItems.some((child) => isActiveLink(currentPath, child.link));
  };
  // Determine if a menu link should be active based on the current URL
  const isActiveLink = (currentPath, link) => {
    if (link === "/home")
      return currentPath === "/home" || currentPath === "/home/";
    return currentPath === link || currentPath.startsWith(link + "/");
  };
  const navigate = useNavigate();

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(".sidebar-container") &&
        !event.target.closest(".mobile-menu-button")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen, setIsMobileMenuOpen]);

  useEffect(() => {
    const newState = {};
    menuItems2.forEach((m) => {
      if (m.items && isSubMenuActive(m.items, location.pathname)) {
        newState[m.id] = true;
      }
    });
    setOpenMenus(newState);
  }, [location.pathname]);

  return (
    <>
      {/* Overlay for mobile */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" />
      )}

      {/* Sidebar */}

      <div
        className={`sidebar-container fixed lg:relative w-[300px] h-full font-mont bg-primary text-white shadow-custom-medium z-50 transition-all duration-300 ease-in-out flex flex-col ${
          isMobileMenuOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="flex justify-between items-center">
          <div className="font-semibold px-3 pt-4 text-[22px]">
            Jaina Jewellers
          </div>
          <button
            onClick={closeMobileMenu}
            className="lg:hidden p-2 text-white mt-4 mr-2"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="mt-4 font-mont font-semibold flex-grow px-2 overflow-y-auto">
          {menuItems.map(({ id, link, icon, label }) => (
            <div
              key={id}
              className="mb-2"
              onClick={() => {
                closeMobileMenu();
              }}
            >
              <Link to={link}>
                <div
                  className={`flex items-center px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200 ${
                    isActiveLink(location.pathname, link)
                      ? "bg-second text-primary"
                      : "text-fourth"
                  }`}
                >
                  <div className="mr-3">{icon}</div>
                  <p>{label}</p>
                </div>
              </Link>
            </div>
          ))}

          <div className="border-b my-4 border-gray-600"></div>
          {menuItems2.map((item) => {
            const isParentActive = item.items
              ? isSubMenuActive(item.items, location.pathname)
              : isActiveLink(location.pathname, item.link);

            return (
              <div key={item.id} className="mb-2">
                {/* PARENT ITEM */}
                <div
                  onClick={() => {
                    if (item.items) {
                      toggleSubMenu(item.id);
                    } else {
                      closeMobileMenu();
                      navigate(item.link);
                    }
                  }}
                  className={`flex justify-between items-center px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200
          ${isParentActive ? "bg-second text-primary" : "text-fourth"}
        `}
                >
                  <div className="flex items-center">
                    <div className="mr-3">{item.icon}</div>
                    <p>{item.label}</p>
                  </div>

                  {item.items && (
                    <span className="text-xs opacity-80">
                      {openMenus[item.id] ? "▲" : "▼"}
                    </span>
                  )}
                </div>

                {/* SUBMENU ITEMS */}
                {item.items && (
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openMenus[item.id] ? "max-h-[500px]" : "max-h-0"
                    }`}
                  >
                    {item.items.map((child) => {
                      const isChildActive = isActiveLink(
                        location.pathname,
                        child.link
                      );

                      return (
                        <Link
                          to={child.link}
                          key={child.id}
                          onClick={closeMobileMenu}
                          className={`flex items-center ml-6 mt-1 px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200
                  ${isChildActive ? "bg-second text-primary" : "text-fourth"}
                `}
                        >
                          <div className="mr-3">{child.icon}</div>
                          <p>{child.label}</p>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-auto">
          <div
            onClick={() => {
              localStorage.removeItem("JainaAccessToken");
              localStorage.removeItem("JainaUser");
              localStorage.removeItem("webidInfo")
              localStorage.removeItem("userInfo")
              localStorage.removeItem("fyearInfo")
              navigate("/");
            }}
            className="flex items-center px-3 py-2 text-sm rounded-[10px] cursor-pointer hover:bg-second/30 transition-all duration-200"
          >
            <div className="mr-3">
              <LogoutOutlinedIcon />
            </div>
            <p>Logout</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideMenu;

// bg-white search, border,header ledger,bg-white, add item detail in model
